import clsx from "clsx";
import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  editFormDataAF,
  formTabControlsSF,
  IRideDto,
  isPastTaxiSupplierRide,
  RideCrudModeKeyTuple,
  RideTabsEnum,
} from "@ryde/shared";

import { FormControlsWrapper } from "../../../../layout-edit";
import { RideTabsTabAdvancedStyled } from "./ride.styled";

interface IRideTabsTabAdvanced {
  tab: RideTabsEnum;
}

export const RideTabsTabAdvanced: FC<IRideTabsTabAdvanced> = ({ tab }) => {
  const { entity } = useCrudEditContext<IRideDto>();
  const currentTabControls = useRecoilValue(formTabControlsSF(entity));
  const rideDto = useRecoilValue<IRideDto | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );

  // RYDE-7633: lock every advanced field when the ride is a past taxi-supplier ride (read-only,
  // also enforced server-side).
  const isReadOnlyPastTaxi = useMemo(
    () => isPastTaxiSupplierRide(rideDto),
    [rideDto],
  );

  return (
    <RideTabsTabAdvancedStyled
      className={clsx({ displayNone: tab !== RideTabsEnum.Advanced })}
    >
      <FormControlsWrapper
        controls={currentTabControls}
        disabled={isReadOnlyPastTaxi}
      />
    </RideTabsTabAdvancedStyled>
  );
};
